import type { LocationQuery, LocationQueryValue } from 'vue-router';
import { compareVersion } from '@pet/base.utils';
import { invoke } from '@yoda/bridge';
import type { MarqueeItem } from '@/types/cool-plan';

export const formatCashValue = (cash: number): string => {
    let result = '';
    if (cash >= 0) {
        if (Math.floor(cash) < 100) {
            result = cash.toFixed(2);
        } else {
            result = `${cash}`;
        }
    }
    return result;
};

export const getOpenFromByQuery = (query: LocationQuery): string => {
    if (query.shareId as string) {
        // 如果是从分享页进来的，不需要上报
        return '';
    } else {
        return (query.openFrom as string) ?? '';
    }
};

export const getAdidFromByQuery = (query: LocationQuery): string => {
    if (query.adId as string) {
        return query.adId as string;
    }
    try {
        return JSON.parse((query.attributionParam as string) ?? '{}')?.ug_adid;
    } catch (error) {
        return '';
    }
};

/**
 * gt: app 版本号大于传入的该版本
 * lt: app 版本号小于传入的该版本
 * eq: 版本号相同
 * @param baseVersion 版本号
 */
export async function compareAppVersion(baseVersion: string) {
    const d = await invoke('webview.getDeviceInfo');
    return compareVersion(d.data.appVersion ?? '', baseVersion);
}

/**
 * 是否满足该版本限制（>=）
 * @param version 版本号
 */
export async function meetAppVersionLimit(version: string) {
    const comparison = await compareAppVersion(version);
    return comparison !== 'lt';
}

const getRandomNum = (max: number, min = 0) => Math.floor(Math.random() * (max - min + 1) + min);

export const getRandomMarqueeList = (value: number | number[], count: number) => {
    const randomNameStr =
        '陈8华玲狐城见张1宛动风涟白大！忧表妹*雪32丫]不7a亡屿羽翼游～五生简单46遇o七戒哦哈怕A珍菲快午水可爱罗嗦幸恒儿（9士根文情晓娃卖万心好豆奶Mn美姐小0看我夏过.亲影草。阿多叶流娜/誠长喜新刀';
    const len = randomNameStr.length;
    // 随机获取数组 value 中的一个
    const randomText = () => {
        let num = 8;
        if (typeof value === 'number') {
            num = value;
        } else if (Array.isArray(value) && value?.length > 0) {
            num = value[getRandomNum(value.length - 1)] as number;
        }
        const textList = [`成功领取${num}元补贴`, '已抢购补贴商品', '正在抢购'];
        return String(textList[getRandomNum(textList.length - 1)]);
    };
    const list: Array<MarqueeItem> = Array.from({ length: count }, () => ({
        text: `${String(randomNameStr[getRandomNum(len - 1)])}***${String(
            randomNameStr[getRandomNum(len - 1)],
        )} ${randomText()}`,
    }));
    return list;
};

export const getTimestampByHour = (hour: number) => {
    return Date.now() + hour * 60 * 60 * 1000;
};

export const transformQueryToString = (
    params: string | string[] | LocationQueryValue | LocationQueryValue[] | undefined,
): string => {
    if (typeof params === 'undefined') {
        return '';
    } else if (typeof params === 'string') {
        return params;
    } else {
        return params?.toString() ?? '';
    }
};
